module.exports = __webpack_public_path__ + "static/media/Copy.103fe4af.svg";